import { addDays, differenceInDays } from 'date-fns';
import { ConceptCode } from '@tiendanube/common';
import { useStoreStatus } from 'domains/Auth/hooks';
import useGetPlanDebt from 'domains/Auth/hooks/useGetPlanDebt';
import { useGetAppsListQuery } from 'domains/PartnersApps/partnersAppsApi';
import { isAppRelatedConcept } from '../pages/utils';

const DAYS_TILL_APP_EXPIRATION = 10;

export default function useExpirationDate(
  conceptCode?: ConceptCode,
  externalReference?: string,
) {
  const isPlan = conceptCode === 'plan-cost';
  const isApp = conceptCode && isAppRelatedConcept(conceptCode);
  const { planDebtData, shouldUseDebtData } = useGetPlanDebt();
  const { adminDisableDate } = useStoreStatus();

  const adminDownDate = shouldUseDebtData
    ? planDebtData?.adminDownDate
    : adminDisableDate;

  const { data: appsList } = useGetAppsListQuery(undefined, { skip: !isApp });
  const app = isApp
    ? appsList?.find(({ id }) => id === externalReference)
    : undefined;

  const daysTillAppExpiration =
    app && app.daysRemaining + DAYS_TILL_APP_EXPIRATION;
  const appExpirationDate = app?.endOfContractDate
    ? addDays(new Date(app.endOfContractDate), DAYS_TILL_APP_EXPIRATION)
    : undefined;

  const expiresIn = isPlan
    ? adminDownDate
      ? differenceInDays(new Date(adminDownDate), new Date())
      : undefined
    : daysTillAppExpiration;

  const expirationDate = isPlan
    ? adminDownDate
      ? new Date(adminDownDate)
      : undefined
    : appExpirationDate;

  const appName = app?.name;

  return { expiresIn, expirationDate, appName };
}
